export interface ILocationItem {
    postal_code: string
    area_name: string
    city_name: string
    state_name: string
    country_name: string
    area_id: number
    city_id: number
    state_id: number
    country_id: number
    district_name?: string
    district_id?: number
}

export interface IDistrictItem {
    district_id: number
    district_name: string
    state_id: number
    state_name: string
}

export interface IDistrictResponseData {
    success: boolean
    message: string
    data: IDistrictItem[]
    pagination?: {
        total: number
        page: number
        limit: number
        totalPage: number
    }
    district_name?: string
    district_id?: number
}

export interface IDistrictItem {
    district_id: number
    district_name: string
    state_id: number
    state_name: string
}

export interface IDistrictResponseData {
    success: boolean
    message: string
    data: IDistrictItem[]
    pagination?: {
        total: number
        page: number
        limit: number
        totalPage: number
    }
}

export interface ILocationResponseData {
    success: boolean
    message: string
    data: ILocationItem[]
    pagination: {
        total: number
        page: number
        limit: number
        totalPage: number
    }
}

export enum ELocationQueryParam {
    POSTAL_CODES = 'postal_codes',
    STATE_NAME = 'state_name',
    STATE_ID = 'state_id',
}

export enum ELocationType {
    COUNTRY = 'country',
    STATE = 'state',
    DISTRICT = 'district',
    CITY = 'city',
    WARD = 'ward',
}

export type LocationType = ELocationType

export interface ILocationByTypeItem {
    id: number
    name: string
    type: LocationType
}

export interface ILocationByTypeResponse {
    success: boolean
    message: string
    data: ILocationByTypeItem[]
    pagination: {
        total: number
        page: number
        limit: number
        totalPage: number
    }
}

export interface ILocationAncestryPathItem {
    id: number
    name: string
    type: LocationType
}

export interface ILocationAncestryResponse {
    success: boolean
    message: string
    path: ILocationAncestryPathItem[]
    path_names: string[]
    path_ids: number[]
}
